import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

//utils
import SeguroPermite from '../../../components/funcionales/seguropermite'

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'
var moment = require('moment');

const DetalleEmpNivel1 = props => {
  return (
    <option>{props.elemento.descrEmpresa}</option>
  )
};

const ListaEmp = ({handleChange, list}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleEmpNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrEmpresa" id="miLista" onChange={(ev)=>handleChange(ev)}>
        {/* <option value="">Seleccionar Empresa...</option> */}
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const DetalleNivelPla1 = props => {
  return (
    <option dato1={props.elemento.codPlanta?props.elemento.codPlanta:''}>{props.elemento.descrPlanta}</option>
  )
};

const ListaPl = ({handleChange, list, handleLista}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivelPla1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrPlanta" id="miLista1" onChange={(ev)=>handleChange(ev)}>
        {/* <option value="">Seleccionar planta...</option> */}
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const DetalleNivelSec1 = props => {
  return (
    <option dato1={props.elemento.codSeccion?props.elemento.codSeccion:''}>{props.elemento.descrSeccion}</option>
  )
};

const ListaSe = ({handleChange, list, handleLista}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivelSec1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrSeccion" id="miLista2" onChange={(ev)=>handleChange(ev)}>
        {/* <option value="">Seleccionar sección...</option> */}
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const DetalleNivelEqu1 = props => {
  return (
    <option dato1={props.elemento.codEquipo?props.elemento.codEquipo:''}
      dato2={props.elemento.nombreUsuario?props.elemento.nombreUsuario:''}
      dato3={props.elemento.cedula?props.elemento.cedula:''}
      dato4={props.elemento.acumulado?props.elemento.acumulado:0}
      dato5={props.elemento.descrPrograma?props.elemento.descrPrograma:'Sin programa'}
    >
      {props.elemento.descrEquipo}
    </option>
  )
};

const ListaEq = ({handleChange, list, handleLista}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivelEqu1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrEquipo" id="miLista3" onChange={(ev)=>handleChange(ev)}>
        {/* <option value="">Seleccionar equipo...</option> */}
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const DetalleNivelCom1 = props => {
  return (
    <option dato1={props.elemento.codComponente?props.elemento.codComponente:''}>{props.elemento.descrComponente}</option>
  )
};

const ListaCo = ({handleChange, list, handleLista}) => {
  // console.log(list)
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivelCom1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrComponente" id="miLista4" onChange={(ev)=>handleChange(ev)}>
        {/* <option value="">Seleccionar componente...</option> */}
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const DetalleNivelMec1 = props => {
  return (
    <option dato1={props.elemento.codMecanismo?props.elemento.codMecanismo:''}
      dato2={props.elemento.codigoQR?props.elemento.codigoQR:''}
      dato3={props.elemento.claseLub?props.elemento.claseLub:''}
      dato4={props.elemento.descrAplicacion?props.elemento.descrAplicacion:''}
      dato5={props.elemento.descrFabricante?props.elemento.descrFabricante:''}
      dato6={props.elemento.descrLubricante?props.elemento.descrLubricante:''}
      dato7={props.elemento.categoriaLub?props.elemento.categoriaLub:''}
      dato8={props.elemento.tipoLub?props.elemento.tipoLub:''}
      dato9={props.elemento.tipoFrecuencia?props.elemento.tipoFrecuencia:''}
      dato10={props.elemento.abrevUnidadTF?props.elemento.abrevUnidadTF:''}
      dato11={props.elemento.cantidadTotal?props.elemento.cantidadTotal:0}
      dato12={props.elemento.descrUnidad?props.elemento.descrUnidad:''}
      dato13={props.elemento.abrevUnidad?props.elemento.abrevUnidad:''}
      dato14={props.elemento.descrUtilidad?props.elemento.descrUtilidad:''}
    >{props.elemento.descrMecanismo}
    </option>
  )
};

const ListaMe = ({handleChange, list, handleLista}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivelMec1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrMecanismo" id="miLista5" onChange={(ev)=>handleChange(ev)}>
        {/* <option value="">Seleccionar mecanismo...</option> */}
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const DetalleNivelHa1 = props => {
  return (
    <option>{props.elemento.descrHallazgo}</option>
  )
};

const ListaHa = ({handleChange, list, handleLista}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivelHa1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrHallazgo" id="miLista6" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar tipo de hallazgo...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const DetalleNivelTa1 = props => {
  return (
    <option>{props.elemento.descrTarea}</option>
  )
};

const ListaTa = ({handleChange, list, handleLista}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivelTa1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrTarea" id="miLista7" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar tarea...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const ListaMod = ({handleChange, handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="modoTarea" id="miLista8" onChange={(ev)=>handleChange(ev)}>
        <option>Seleccionar...</option>
        <option>Equipo en operación</option>
        <option>Equipo detenido</option>
      </select>
    </div>
  )
};
const ListaSISO = ({handleChange, handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="requiereSISO" id="miLista10" onChange={(ev)=>handleChange(ev)}>
        <option>Seleccionar...</option>
        <option>Si requiere SISO</option>
        <option>No requiere SISO</option>
      </select>
    </div>
  )
};

const DetalleUsuNivel1 = props => {
  return (
    <option dato1={props.elemento.email?props.elemento.email:""} 
    dato2={props.elemento.telefono?props.elemento.telefono:""} 
    dato3={props.elemento.cedula?props.elemento.cedula:""}>
    {props.elemento.nombreUsuario}</option>
  )
};

const ListaUsu = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleUsuNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="nombreUsuario" id="miLista9" onChange={(ev)=>handleChange(ev)}>
        {/* <option value="">Seleccionar usuario...</option> */}
        {Nivel1Detalle}
      </select>
    </div>
  )
};

// const AddEmpresa2 = ({this.props.styles, handleSubmit, handleChange, args, errors}) => {
  class AddOtHallazgo2 extends React.Component{
    state={argsAdd: {descrEmpresa: "Seleccionar Empresa...", descrPlanta: "Seleccionar planta...",
      descrSeccion: "Seleccionar sección...", descrEquipo: "Seleccionar equipo...",
      descrComponente: "Seleccionar componente...", descrMecanismo: "Seleccionar mecanismo...",
      file: "", imgAntes: "", file1: "", imgDespues: ""},
      listPl: [], listSe: [], listEq: [], listCo: [], listMe: [], listUs: [],
      argsQuery: `{"$unwind": "$secciones"},
      {$project: {_id: 1, idPlanta: "$_id",
        descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: '$secciones.codSeccion',
        descrSeccion: '$secciones.descrSeccion'}},
      {$sort: {descrPlanta: 1, descrSeccion: 1}}`,
      argsQuery1: `{"$unwind": "$secciones"},
      {"$unwind": "$secciones.equipos"},
      {$project: {_id: 1, idPlanta: "$_id",
        descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: '$secciones.codSeccion',
        descrSeccion: '$secciones.descrSeccion', codEquipo: '$secciones.equipos.codEquipo',
        descrEquipo: '$secciones.equipos.descrEquipo', nombreUsuario: '$secciones.equipos.nombreUsuario',
        cedula: '$secciones.equipos.cedula', acumulado: '$secciones.equipos.acumulado', descrPrograma: '$secciones.equipos.descrPrograma'}},
      {$project: {_id: 1, idPlanta: 1, descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: 1, descrSeccion: 1,
        codEquipo: 1, descrEquipo: 1, nombreUsuario: 1, cedula: 1, acumulado: 1, descrPrograma: 1}},
      {$sort: {descrPlanta: 1, descrSeccion: 1, descrEquipo: 1}}`,
      argsQuery2: `{"$unwind": "$secciones"},
      {"$unwind": "$secciones.equipos"},
      {"$unwind": "$secciones.equipos.componentes"},
      {$project: {_id: 1, idPlanta: "$_id",
        descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: '$secciones.codSeccion',
        descrSeccion: '$secciones.descrSeccion', codEquipo: '$secciones.equipos.codEquipo',
        descrEquipo: '$secciones.equipos.descrEquipo', descrPrograma: '$secciones.equipos.descrPrograma',
        codComponente: '$secciones.equipos.componentes.codComponente',
        descrComponente: '$secciones.equipos.componentes.descrComponente'}},
      {$project: {_id: 1, idPlanta: 1, descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: 1, descrSeccion: 1,
        codEquipo: 1, descrEquipo: 1, descrPrograma: 1, descrComponente: 1}},
      {$sort: {descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, descrComponente: 1, codComponente: 1}}`,
      argsQuery3: `{"$unwind": "$secciones"},
      {"$unwind": "$secciones.equipos"},
      {"$unwind": "$secciones.equipos.componentes"},
      {"$unwind": "$secciones.equipos.componentes.mecanismos"},
      {$project: {_id: 1, idPlanta: "$_id",
        descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: '$secciones.codSeccion',
        descrSeccion: '$secciones.descrSeccion', codEquipo: '$secciones.equipos.codEquipo',
        descrEquipo: '$secciones.equipos.descrEquipo', descrPrograma: '$secciones.equipos.descrPrograma',
        descrComponente: '$secciones.equipos.componentes.descrComponente',
        codMecanismo: '$secciones.equipos.componentes.mecanismos.codMecanismo',
        descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
        claseLub: '$secciones.equipos.componentes.mecanismos.claseLub',
        descrAplicacion: '$secciones.equipos.componentes.mecanismos.descrAplicacion',
        descrUtilidad: '$secciones.equipos.componentes.mecanismos.descrUtilidad',
        descrFabricante: '$secciones.equipos.componentes.mecanismos.descrFabricante',
        descrLubricante: '$secciones.equipos.componentes.mecanismos.descrLubricante',
        categoriaLub: '$secciones.equipos.componentes.mecanismos.categoriaLub',
        tipoLub: '$secciones.equipos.componentes.mecanismos.tipoLub',
        tipoFrecuencia: '$secciones.equipos.componentes.mecanismos.tipoFrecuencia',
        abrevUnidadTF: '$secciones.equipos.componentes.mecanismos.abrevUnidadTF',
        cantidadTotal: '$secciones.equipos.componentes.mecanismos.cantidadTotal',
        descrUnidad: '$secciones.equipos.componentes.mecanismos.descrUnidad',
        abrevUnidad: '$secciones.equipos.componentes.mecanismos.abrevUnidad',
        codigoQR: '$secciones.equipos.componentes.mecanismos.codigoQR'}},
      {$project: {_id: 1, idPlanta: 1, descrEmpresa: 1, descrPlanta: 1, descrSeccion: 1,
        descrEquipo: 1, descrPrograma: 1, descrComponente: 1, descrMecanismo: 1, codMecanismo: 1,
        claseLub: 1, descrAplicacion: 1, descrFabricante: 1, descrLubricante: 1, categoriaLub: 1,
      tipoLub: 1, tipoFrecuencia: 1, abrevUnidadTF: 1, cantidadTotal: 1, descrUnidad: 1, abrevUnidad: 1, codigoQR: 1}},
      {$sort: {descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, descrComponente: 1, descrMecanismo: 1}}`,
      argsQuery4: `{$project: {_id: 1, idPlanta: "$_id",
        descrEmpresa: 1, codPlanta:1, descrPlanta: 1}},
      {$sort: {descrPlanta: 1}}`
   
    }

    crudBD = async (operacionCRUD, args, i)=>{
      if(args.ctrlCampo === 'CRUD'){
        const {data} = await operacionCRUD({
          variables: args
        });
  
  //Se utiliza para traer el _id del documento creado
        if(args.ctrl_id === 'SI_ID'){
          if(Object.values(data)[0]._id){
            return Object.values(data)[0]._id
          }else{
            return 0
          }
        }
      }else{
        if(args.ctrlCampo === "MANY"){
          const {data} = await operacionCRUD({
            variables: args
          });
        }
      }
    }
  
    updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
      let codigo = 0
      if(argsCrud[0].ctrl_id === 'SI_ID'){
        codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
      }else{
        await this.crudBD(crudColecc[0], argsCrud[0], 0)
      }
      if(codigo!==0){
        for(let i=1; i<totDocCRUD; i++){
          argsCrud[i]._id = codigo
        }
      }
      for(let i=1; i<totDocCRUD; i++){
        await this.crudBD(crudColecc[i], argsCrud[i], i)
      }
    }
  

  nextVal = async (name) => {
    const argsUpd = {
      coleccion: name,
    }
    const response = await this.props.editSeqfindOneAndUpdate({
      variables: argsUpd
    });
    return response.data.editSeqfindOneAndUpdate.seq
  }

  handleChange = async (ev) => {
    const argsAdd = this.state.argsAdd
    
    if(ev.target.name==='file' || ev.target.name==='file1'){
      let file = "", imgAntes = "", file1 = "", imgDespues = ""
      if(ev.target.name==='file'){
        file = ev.target.files[0]
        imgAntes = ev.target.files[0].name
        argsAdd['imgAntes'] = imgAntes
        argsAdd['file'] = file      
      }
      if(ev.target.name==='file1'){
        file1 = ev.target.files[0]
        imgDespues = ev.target.files[0].name
        argsAdd['imgDespues'] = imgDespues
        argsAdd['file1'] = file1      
      }
    }else{
      if(ev.target.name === "descrEmpresa"){
        let empre=ev.target.value
        argsAdd['descrEmpresa'] = empre
        if(empre!=='Seleccionar Empresa...'){
          let argsBuscarPl = {tipoqry: `[${this.state.argsQuery4}, {$match: {'descrEmpresa': '${empre}'}}]`}
          let {data} = await this.props.allPlantaRtes1.refetch(argsBuscarPl)
          let listPl = await data.allPlantaRtes
          
          argsBuscarPl = {tipoqry: `[{$match: {descrEmpresa: {$in: ['${empre}', "Todas..."]}, estado: 'Activo', gestionaHallazgos: 'Si', nombreUsuario: {$ne: 'slcm'}}}]`}
          if(2>1){
            console.log(argsBuscarPl)
            let {data} = await this.props.allUsuariosRtes.refetch(argsBuscarPl)
            let listUs = await data.allUsuariosRtes
            console.log(listUs)
            this.setState({listPl, listUs});
            console.log(this.state.listUs)
          }
        }
      }else{
        if(ev.target.name === "descrPlanta"){
          const argsAdd = this.state.argsAdd
          let planta=ev.target.value
          argsAdd['descrPlanta'] = planta
          let empre = argsAdd['descrEmpresa']
          if(planta!=='Seleccionar planta...'){
            let argsBuscarPl = {tipoqry: `[${this.state.argsQuery}, {$match: {'descrEmpresa': '${empre}', 'descrPlanta': '${planta}'}}]`}
            console.log(argsBuscarPl)
            let {data} = await this.props.allPlantaRtes1.refetch(argsBuscarPl)
            let listSe = await data.allPlantaRtes

            var miLista = document.getElementById("miLista1");
            argsAdd['descrPlanta'] = miLista.options[miLista.selectedIndex].text
            argsAdd['codPlanta'] = miLista.options[miLista.selectedIndex].attributes[0].value
            this.setState({listSe});
          }
        }else{
          if(ev.target.name === "descrSeccion"){
            const argsAdd = this.state.argsAdd
            let seccion=ev.target.value
            argsAdd['descrSeccion'] = seccion
            let empre = argsAdd['descrEmpresa']
            let planta = argsAdd['descrPlanta']
            if(seccion!=='Seleccionar sección...'){
              let argsBuscarPl = {tipoqry: `[${this.state.argsQuery1}, {$match: {'descrEmpresa': '${empre}', 'descrPlanta': '${planta}', 'descrSeccion': '${seccion}'}}]`}
              let {data} = await this.props.allPlantaRtes1.refetch(argsBuscarPl)
              let listEq = await data.allPlantaRtes
              var miLista = document.getElementById("miLista2");
              argsAdd['descrSeccion'] = miLista.options[miLista.selectedIndex].text
              argsAdd['codSeccion'] = miLista.options[miLista.selectedIndex].attributes[0].value
              this.setState({listEq});
            }
          }else{
            if(ev.target.name === "descrEquipo"){
              const argsAdd = this.state.argsAdd
              let equipo=ev.target.value
              argsAdd['descrEquipo'] = equipo
              let empre = argsAdd['descrEmpresa']
              let planta = argsAdd['descrPlanta']
              let seccion = argsAdd['descrSeccion']

              if(equipo!=='Seleccionar equipo...'){
                let argsBuscarPl = {tipoqry: `[${this.state.argsQuery2}, {$match: {'descrEmpresa': '${empre}', 'descrPlanta': '${planta}', 'descrSeccion': '${seccion}', 'descrEquipo': '${equipo}'}}]`}
                let {data} = await this.props.allPlantaRtes1.refetch(argsBuscarPl)
                let listCo = await data.allPlantaRtes
                var miLista = document.getElementById("miLista3");
                argsAdd['descrEquipo'] = miLista.options[miLista.selectedIndex].text
                argsAdd['codEquipo'] = miLista.options[miLista.selectedIndex].attributes[0].value
                argsAdd['nombreUsuario'] = miLista.options[miLista.selectedIndex].attributes[1].value
                argsAdd['cedula'] = miLista.options[miLista.selectedIndex].attributes[2].value
                argsAdd['acumulado'] = miLista.options[miLista.selectedIndex].attributes[3].value
                argsAdd['descrPrograma'] = miLista.options[miLista.selectedIndex].attributes[4].value
                this.setState({listCo});
              }
            }else{
              if(ev.target.name === "descrComponente"){
                const argsAdd = this.state.argsAdd
                let componente=ev.target.value
                argsAdd['descrComponente'] = componente
                let empre = argsAdd['descrEmpresa']
                let planta = argsAdd['descrPlanta']
                let seccion = argsAdd['descrSeccion']
                let equipo = argsAdd['descrEquipo']
                if(componente!=='Seleccionar componente...'){
                  let argsBuscarPl = {tipoqry: `[${this.state.argsQuery3}, {$match: {'descrEmpresa': '${empre}', 'descrPlanta': '${planta}', 'descrSeccion': '${seccion}', 'descrEquipo': '${equipo}', 'descrComponente': '${componente}'}}]`}
                  console.log(argsBuscarPl)
                  let {data} = await this.props.allPlantaRtes1.refetch(argsBuscarPl)
                  let listMe = await data.allPlantaRtes
                  console.log(listMe)
                  var miLista = document.getElementById("miLista4");
                  argsAdd['descrComponente'] = miLista.options[miLista.selectedIndex].text
                  argsAdd['codComponente'] = miLista.options[miLista.selectedIndex].attributes[0].value
                  this.setState({listMe});
                }
              }else{
                if(ev.target.name === "descrMecanismo"){
                  const argsAdd = this.state.argsAdd
                  let mecanismo=ev.target.value
                  argsAdd['descrMecanismo'] = mecanismo
                  if(mecanismo!=='Seleccionar mecanismo...'){
                    var miLista = document.getElementById("miLista5");
                    console.log(miLista)
                    argsAdd['descrMecanismo'] = miLista.options[miLista.selectedIndex].text
                    argsAdd['codMecanismo'] = miLista.options[miLista.selectedIndex].attributes[0].value
                    argsAdd['codigoQR'] = miLista.options[miLista.selectedIndex].attributes[1].value
                    argsAdd['claseLub'] = miLista.options[miLista.selectedIndex].attributes[2].value
                    argsAdd['descrAplicacion'] = miLista.options[miLista.selectedIndex].attributes[3].value
                    argsAdd['descrUtilidad'] = miLista.options[miLista.selectedIndex].attributes[13].value
                    argsAdd['descrFabricante'] = miLista.options[miLista.selectedIndex].attributes[4].value
                    argsAdd['descrLubricante'] = miLista.options[miLista.selectedIndex].attributes[5].value
                    argsAdd['categoriaLub'] = miLista.options[miLista.selectedIndex].attributes[6].value
                    argsAdd['tipoLub'] = miLista.options[miLista.selectedIndex].attributes[7].value
                    argsAdd['tipoFrecuencia'] = miLista.options[miLista.selectedIndex].attributes[8].value
                    argsAdd['abrevUnidadTF'] = miLista.options[miLista.selectedIndex].attributes[9].value
                    argsAdd['cantidadTotal'] = miLista.options[miLista.selectedIndex].attributes[10].value
                    argsAdd['descrUnidad'] = miLista.options[miLista.selectedIndex].attributes[11].value
                    argsAdd['abrevUnidad'] = miLista.options[miLista.selectedIndex].attributes[12].value 
                  }
                }else{
                  argsAdd[ev.target.name] = ev.target.value
                }              
              }            
            }
          }
        }
      }
    }
    this.setState({argsAdd})
  }

  handleSubmit = async (ev, args)=>{
    console.log(args)

    if(args.descrEmpresa!=='Seleccionar Empresa...' && args.descrPlanta!=='Seleccionar planta...' && 
      args.descrSeccion!=='Seleccionar sección...' && args.descrEquipo!=='Seleccionar equipo...' && 
      args.descrComponente!=='Seleccionar componente...' && args.descrMecanismo!=='Seleccionar mecanismo...' && 
      args.descrHallazgo!=='Seleccionar tipo de hallazgo...' && args.descrTarea!=='Seleccionar tarea...' && 
      args.modoTarea!=='Seleccionar...' && args.requiereSISO!=='Seleccionar...' && args.nombreUsuario!=='Seleccionar usuario...'){
      document.body.style.cursor = 'wait'

      let numeroOrden = await this.nextVal('numeroOrden')
      let numeroRuta = await this.nextVal('ruta')

      //Archivo Excel
      let xlsString = []
      let xlsString1 = []
      xlsString1 = ['Ruta', 'OT', 'OT SAP', 'Frecuencia', 'Año', 'Mes', 'Día', 'Planta', 'Sección', 'Equipo', 'Componente',
        'Mecanismo', 'Método', 'Tarea', 'Modo ejec. tarea', 'Requiere SISO', 'Lubricante', 'Cantidad', 'Und', 'Puntos', 'Minutos', 'Realizado?', 'Año real', 'Mes real', 'Día real',
        'Hora real (0-23)', 'Operario real', 'Cant. real', 'Min. real', 'Acum. Horas/Km', 'Temperatura antes lub.', 'Temperatura despues lub.', 
        'Ultrasonido antes lub.', 'Ultrasonido despues lub.', 'Vibraciones antes lub.', 'Vibraciones despues lub.', 'Observación anterior', 'Observación actual', 'Rep. Lab.', 'Inf. Lab.']
      xlsString.push(xlsString1)

      let addColeccPl = [], creaColecc = []
      let campoAgno = ''
      let campoMes = ''
      let campoDia= ''
      let fechaDesde = moment().format('YYYY-MM-DD')
      let fechaHasta = moment().format('YYYY-MM-DD')
      campoAgno = fechaDesde.substring(0, 4)
      campoMes = fechaDesde.substring(5, 7)
      campoDia = fechaDesde.substring(8, 10)        
      let argsPl = {}, argsProg = {}
      let addColeccProg = []
      let descrMetodo = 'Hallazgo'
      // let descrTarea = args.descrTarea
      // let nombreUsuario = args.nombreUsuario?args.nombreUsuario:''
      let cedula = args.cedula?args.cedula:''
      let mail = args.mail?args.mail:''
      let telefono = args.telefono?args.telefono:''
      let codPlanta = args.codPlanta?args.codPlanta:""
      let codSeccion = args.codSeccion?args.codSeccion:""
      let codEquipo = args.codEquipo?args.codEquipo:""
      let descrPrograma = args.descrPrograma?args.descrPrograma:"Sin programa"
      let codComponente = args.codComponente?args.codComponente:""
      let codMecanismo = args.codMecanismo?args.codMecanismo:""
      let imgAntes = args.imgAntes?args.imgAntes:""
      let imgDespues = args.imgDespues?args.imgDespues:""
      let videoAntes = args.videoAntes?args.videoAntes:""
      let videoDespues = args.videoDespues?args.videoDespues:""      
      let codigoQR = args.codigoQR?args.codigoQR:""
      let descrFabricante = args.descrFabricante?args.descrFabricante:''
      let cantidadTotal = args.cantidadTotal?args.cantidadTotal:0
      let acumulado = args.acumulado?args.acumulado:0
      // let observaciones = args.observaciones?args.observaciones:""
      let acumReal = args.acumulado?args.acumulado:0
      let modoTarea = 'I'
      if(args.modoTarea==='Equipo detenido'){
        modoTarea = 'O'
      }
      let requiereSISO = 'No'
      if(args.requiereSISO==='Si requiere SISO'){
        requiereSISO = 'Si'
      }

      console.log(numeroOrden)
      let argsAdd = {
        "ruta": numeroRuta,
        "numeroOrden": numeroOrden,
        "ordenSAP": "",
        "estadoOrden": "Abierto",
        "fechaIni": fechaDesde,
        "fechaFin": fechaHasta,
        "nombreUsuario": args.nombreUsuario,
        "cedula": cedula,
        "mail": mail,
        "telefono": telefono,
        "descrEmpresa": args.descrEmpresa,
        "descrPlanta": args.descrPlanta,
        "codPlanta": codPlanta,
        "descrSeccion": args.descrSeccion,
        "codSeccion": codSeccion,
        "descrEquipo": args.descrEquipo,
        "codEquipo": codEquipo,
        "descrPrograma": descrPrograma,
        "descrComponente": args.descrComponente,
        "codComponente": codComponente,
        "descrMecanismo": args.descrMecanismo,
        "codMecanismo": codMecanismo,
        "codigoQR": codigoQR,
        "claseLub": args.claseLub,
        "tipoLub": args.tipoLub,
        "Fabricante": descrFabricante,
        "descrLubricante": args.descrLubricante,
        "descrUtilidad": args.descrUtilidad,
        "descrAplicacion": args.descrAplicacion,
        "tipoFrecuencia": args.tipoFrecuencia,
        "abrevUnidadTF": 'Hallazgo',
        "cantidadTotal": cantidadTotal,
        "descrUnidad": args.descrUnidad,
        "abrevUnidad": args.abrevUnidad,
        "cantidad": 0,
        "puntosLub": args.puntosLub?args.puntosLub:0,
        "minutos": args.minutos?args.minutos:0,
        "descrMetodo": descrMetodo,
        "descrTarea": args.descrTarea,
        "modoTarea": modoTarea,
        "requiereSISO": requiereSISO,
        "descrHallazgo": args.descrHallazgo,
        "descrFrecuencia": 'Hallazgo',
        "descrFrecuenciaPre": "",
        "acumulado": acumulado,
        "fechaUlt": "",
        "fechaProx": "",
        "acumUlt": 0,
        "acumProx": 0,
        "observaciones": args.observaciones?args.observaciones:"",
        "realizado": "N",
        "alimSistema": "N",
        "acumReal": acumulado,
        "cantidadReal": 0,
        "minutosReal": 0,  
        "observacionesReal": "",
        "nombreUsuarioReal": nombreUsuario,
        "cedulaReal": cedula,
        "codProcedimiento": "",
        "nombreArchivo": "",
        "numeroInflab": 0,
        "mecInflab": 0,
        "fechaProg": fechaDesde,
        "fechaReal": fechaDesde,
        "horaReal": 8,
        "tempAntesLub": 0,
        "tempDespuesLub": 0,
        "ultraAntesLub": 0,
        "ultraDespuesLub": 0,
        "vibraAntesLub": 0,
        "vibraDespuesLub": 0,
        "imgAntes": imgAntes,
        "imgDespues": imgDespues,
        "videoAntes": videoAntes,
        "videoDespues": videoDespues,
        "tipoAct": "Web",
      }
      if(!args.file){
        argsAdd['file'] = "";
      }else{
        argsAdd['file'] = args.file;
        let response = await this.props.singleUpload({variables: {file: args.file}}); 
      }
      if(!args.file1){
        argsAdd['file1'] = "";
      }else{
        argsAdd['file1'] = args.file1;
        let response = await this.props.singleUpload({variables: {file: args.file1}}); 
      }      
      let response = await this.props.fecha({
        variables: {}
      }); 
      const {fechaHoraHoy} = response.data.fecha
      argsAdd['fechaCreate'] = fechaHoraHoy;
      argsAdd['usuarioCreate'] = localStorage.getItem('userLogin')
      
      response = await this.props.createOrden({
        variables: argsAdd
      });
      const {errors, success} = response.data.createOrden;

      if (!success){
        this.setState({errorAdd: errors})
      }else{
        console.log(document.getElementById)
        document.getElementById("file").value = "";
        document.getElementById("file1").value = ""
        var descrEmpresa = document.getElementById("miLista");
        var descrPlanta = document.getElementById("miLista1");
        var descrSeccion = document.getElementById("miLista2");
        var descrEquipo = document.getElementById("miLista3");
        var descrComponente = document.getElementById("miLista4");
        var descrMecanismo = document.getElementById("miLista5");
        var descrHallazgo = document.getElementById("miLista6");
        var descrTarea = document.getElementById("miLista7");
        var nombreUsuario = document.getElementById("miLista9");

        var observaciones = document.getElementById("observaciones");
        descrEmpresa.options.selectedIndex = 0    
        descrPlanta.options.selectedIndex = 0  
        descrSeccion.options.selectedIndex = 0
        descrEquipo.options.selectedIndex = 0
        descrComponente.options.selectedIndex = 0
        descrMecanismo.options.selectedIndex = 0
        descrHallazgo.options.selectedIndex = 0
        descrTarea.options.selectedIndex = 0  
        nombreUsuario.options.selectedIndex = 0  
        observaciones.value = ""
        this.setState({errorAdd: []})
        this.setState({argsAdd: {}})
        this.props.allEmpresa.refetch()
      }

      xlsString1 = [numeroRuta, numeroOrden, '', 'Hallazgo', campoAgno, campoMes, campoDia, args.descrPlanta,
      args.descrSeccion, args.descrEquipo, args.descrComponente, args.descrMecanismo, 
      descrMetodo, args.descrTarea, modoTarea, requiereSISO, args.descrLubricante, 0, 
      args.abrevUnidad, args.puntosLub, args.minutos, 'S', campoAgno, campoMes, campoDia, 8,
      cedula, 0, 0, acumulado, '', '', '', '', '', '', args.observaciones, '', 0, 0]

      xlsString.push(xlsString1)

      var wb = XLSX.utils.book_new();

      wb.Props = {
        Title: "SheetJS Tutorial",
        Subject: "Test",
        Author: "Red Stapler",
        CreatedDate: new Date(2017,12,19)
      };

      wb.SheetNames.push("Ordenes"); 

      let ws_data = xlsString;

      let ws = XLSX.utils.aoa_to_sheet(ws_data);
      wb.Sheets["Ordenes"] = ws;
      let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
      function s2ab(s) { 
        let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
        let view = new Uint8Array(buf);  //create uint8array as viewer
        for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
        return buf;    
      }
      saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'Ruta_'+numeroRuta+'_'+numeroOrden+'_'+args.descrEmpresa+'.xlsx');
  //FIN Exportar a XLS

      document.body.style.cursor = 'default'

      this.setState({open: false, confirmaAct: false})
    }else{
      alert("!! No existen registros para programar, debe seleccionar los datos completos !!")
    }
  }

  render(){
  const {argsAdd} = this.state.argsAdd;
  const listPl = this.state.listPl;
  const listSe = this.state.listSe;
  const listEq = this.state.listEq;
  const listCo = this.state.listCo;
  const listMe = this.state.listMe;
  const listUs = this.state.listUs;

  let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
  let args = Object.assign({}, this.state.argsAdd, argsAdd)

  let descrEmpresaUA=localStorage.getItem('Empresa')

  let list1 = [], list2 = [], list3 = [], list4 = [], list5 = [], list6 = [], list7 = []
  list1.push({descrPlanta: "Seleccionar planta...", _id: 0})
  list3.push({descrSeccion: "Seleccionar sección...", _id: 0})
  list4.push({descrEquipo: "Seleccionar equipo...", _id: 0})
  list5.push({descrComponente: "Seleccionar componente...", _id: 0})
  list6.push({descrMecanismo: "Seleccionar mecanismo...", _id: 0})
  list7.push({nombreUsuario: "Seleccionar usuario...", _id: 0})

  if(descrEmpresaUA==="Todas..."){
    list2.push({descrEmpresa: "Seleccionar Empresa...", _id: 0})
    if(this.props.allEmpresa.allEmpresa){
      this.props.allEmpresa.allEmpresa.forEach((elemento, ii) => {
        if(elemento.rutas==='S'){
          list2.push({descrEmpresa: elemento.descrEmpresa, _id: ii+1})
        }
      })
    }
  }else{
    list2.push({descrEmpresa: descrEmpresaUA, _id: 0})
  }

  if (args.descrEmpresa!=="Seleccionar Empresa..."){
    listPl.forEach((elemento, ii) => {
      list1.push({descrPlanta: elemento.descrPlanta, codPlanta: elemento.codPlanta?elemento.codPlanta:'', _id: ii+1})
    })
    listUs.forEach((elemento, ii) => {
      list7.push({nombreUsuario: elemento.nombreUsuario, cedula: elemento.cedula?elemento.cedula:'', mail: elemento.mail?elemento.mail:'', telefono: elemento.telefono?elemento.telefono:'', _id: ii+1})
    })  
  }

  if (args.descrPlanta!=="Seleccionar planta..."){
    console.log(listSe)
    listSe.forEach((elemento, ii) => {
      list3.push({descrSeccion: elemento.descrSeccion, codSeccion: elemento.codSeccion?elemento.codSeccion:'', _id: ii+1})
    })
  }

  if (args.descrSeccion!=="Seleccionar sección..."){
    listEq.forEach((elemento, ii) => {
      list4.push({descrEquipo: elemento.descrEquipo, codEquipo: elemento.codEquipo?elemento.codEquipo:'', 
        nombreUsuario: elemento.nombreUsuario?elemento.nombreUsuario:'', 
        cedula: elemento.cedula?elemento.cedula:'', acumulado: elemento.acumulado?elemento.acumulado:0, _id: ii+1})
    })
  }

  if (args.descrEquipo!=="Seleccionar equipo..."){
    listCo.forEach((elemento, ii) => {
      list5.push({descrComponente: elemento.descrComponente, codComponente: elemento.codComponente?elemento.codComponente:'', _id: ii+1})
    })
  }

  if (args.descrComponente!=="Seleccionar componente..."){
    listMe.forEach((elemento, ii) => {
      console.log(elemento)
      list6.push({descrMecanismo: elemento.descrMecanismo, codMecanismo: elemento.codMecanismo?elemento.codMecanismo:'', _id: ii+1,
        codigoQR: elemento.codigoQR?elemento.codigoQR:'', claseLub: elemento.claseLub, 
        descrAplicacion: elemento.descrAplicacion, descrFabricante: elemento.descrFabricante?elemento.descrFabricante:'', 
        descrLubricante: elemento.descrLubricante, categoriaLub: elemento.categoriaLub, 
        tipoLub: elemento.tipoLub, tipoFrecuencia: elemento.tipoFrecuencia, 
        abrevUnidadTF: elemento.abrevUnidadTF, cantidadTotal: elemento.cantidadTotal?elemento.cantidadTotal:0, 
        descrUnidad: elemento.descrUnidad, abrevUnidad: elemento.abrevUnidad})
    })
  }
  let lista2 = []
  if(this.props.list10){
    lista2 = this.props.list10
  }
  let listTa=[]
  // listTa = lista2.filter(elemento => elemento.tipoLub==='Hallazgo')
  listTa = lista2

  return(
    <div>
      <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          OT nueva
      </button>
      <div style={this.props.styles.box}>
        <Form onSubmit={(ev)=>this.handleSubmit(ev, args)}>
          <div className="ui five column stackable grid">
            <div className="row container">
              <div className="column" width="20%">
                <Form.Field>
                  <ListaEmp handleChange={this.handleChange} list={list2}/>
                </Form.Field>
              </div>
              <div className="column" width="20%">
                <Form.Field>
                  <ListaPl handleChange={this.handleChange} list={list1} handleLista={this.props.handleLista}/>
                </Form.Field>
              </div>
              <div className="column" width="20%">
                <Form.Field>
                  <ListaSe handleChange={this.handleChange} list={list3} handleLista={this.props.handleLista1}/>
                </Form.Field>
              </div>
              <div className="column" width="20%">
                <Form.Field>
                  <ListaEq handleChange={this.handleChange} list={list4} handleLista={this.props.handleLista2}/>
                </Form.Field>
              </div>
              <div className="column" width="20%">
                <Form.Field>
                  <ListaCo handleChange={this.handleChange} list={list5} handleLista={this.props.handleLista3}/>
                </Form.Field>
              </div>
              <div className="column" width="20%">
                <Form.Field>
                  <ListaMe handleChange={this.handleChange} list={list6} handleLista={this.props.handleLista4}/>
                </Form.Field>
              </div>
            {/* </div>
          </div>
          <div className="ui three column stackable grid">
            <div className="row container"> */}
              <div className="column" style={{width: '20%'}}>
                <Form.Field>
                  <ListaHa handleChange={this.handleChange} list={this.props.list} handleLista={this.props.handleLista5}/>
                </Form.Field>
              </div>
              <div className="column" style={{width: '20%'}}>
                <Form.Field>
                  <ListaTa handleChange={this.handleChange} list={listTa} handleLista={this.props.handleLista6}/>
                </Form.Field>              
              </div>
              <div className="column" style={{width: "20%"}}>
                <Form.Field>
                  <ListaMod handleChange={this.handleChange} handleLista={this.props.handleLista7}/>
                </Form.Field>                
              </div>
              <div className="column" style={{width: "20%"}}>
                <Form.Field>
                  <ListaSISO handleChange={this.handleChange} handleLista={this.props.handleLista9}/>
                </Form.Field>                
              </div>              
              <div className="column" style={{width: "20%"}}>
                <Form.Field>
                  <ListaUsu handleChange={this.handleChange} list={list7} handleLista={this.props.handleLista8}/>
                </Form.Field>                
              </div>            
            </div>
          </div>
          <div className="ui two column stackable grid">
            <div className="row container">
              <div className="column" style={{width: '50%'}}>
                <Form.Field>
                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Seleccionar imagen antes de OT...&nbsp;&nbsp;
                    </label>
                    <input id="file" name="file" type="file" accept="image/*" style={estilos} onChange={this.handleChange}></input>
                </Form.Field> 
                </div>
                  <div className="column" style={{width: '50%'}}>
                  <Form.Field>
                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Seleccionar imagen después de OT...&nbsp;&nbsp;
                    </label>
                    <input id="file1" name="file1" type="file" accept="image/*" style={estilos} onChange={this.handleChange}></input>
                </Form.Field>  
              </div>
            </div>
          </div>
          <div className="ui one column stackable grid">
            <div className="row container">              
              <div className="column" width="100%">  
                <Form.Field>                
                  <label style={this.props.styles.label}>Observaciones</label>
                  <textarea name="observaciones" id="observaciones" cols="40" rows="3" onChange={this.handleChange}></textarea>                
                </Form.Field>
              </div>
            </div>
          </div>

          <Button style={this.props.styles.confirmar} type='submit' fluid>
            AGREGAR
          </Button>

          {
            this.props.errors.length?<Message negative header="Los siguientes errores:"
            list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
          }
        </Form>
      </div>
    </div>
  )
  }
}

// export default AddEmpresa2
export default compose(
  graphql(queries.mutation.singleUpload, {name:'singleUpload'}),
  graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),
  graphql(queries.query.allUsuariosRtes, {name:'allUsuariosRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {nombreUsuario: 'Seleccionar Usuario...'}}]`}}}}),
  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),
  graphql(queries.mutation.createOrden, {name:'createOrden'}),
  graphql(queries.mutation.editPlantaEstructura, {name:'editPlantaEstructura'}),

  graphql(queries.mutation.editSeqfindOneAndUpdate, {name:'editSeqfindOneAndUpdate'}),
  graphql(queries.mutation.editSequence, {name:'editSequence'}),
  graphql(queries.query.getParametro, {name:'getParametro', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.editParametro, {name:'editParametro'}),
  graphql(queries.mutation.fecha, {name:'fecha'}),


  )(AddOtHallazgo2)